import React, { useState } from "react";
import {
  Container,
  Title,
  Description,
  SignIn,
  Wrapper,
  FormWrapper,
  Form,
  Checkbox,
  Textarea,
  Button,
} from "./style";
import {useHistory} from 'react-router-dom'

export default function Reply() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [comment, setComment] = useState("");
  const history = useHistory()
  const onSignIn = () => {
    console.log('test')
    history.push('/singin')
  }
  return (
    <Container>
      <Wrapper>
        <Title>Leave a reply</Title>
        <Description onClick={onSignIn}>
          Already have an account? <SignIn onClick={onSignIn}>Sign in</SignIn> to leave a reply.{" "}
        </Description>
        <FormWrapper>
          <Form autoComplete={"on"}>
            <Form.Label>Name</Form.Label>
            <Form.Input
              onChange={(e) => setName(e.target.value)}
              type="text"
              placeholder="name"
              autoComplete={"on"}
            />
          </Form>
          <Form>
            <Form.Label>Email address </Form.Label>
            <Form.Input
              onChange={(e) => setEmail(e.target.value)}
              type="text"
              placeholder="email"
            />
          </Form>
        </FormWrapper>
        <Form checkbox>
          <Checkbox type="checkbox" />
          <Form.Label save>
            Save my name and email in this browser for a next time comment.
          </Form.Label>
        </Form>
        <Form>
          <Form.Label>Comment</Form.Label>
          <Textarea
            onChange={(e) => setComment(e.target.value)}
            rows="8"
            cols="50"
            placeholder="Space for your comments"
          />
        </Form>
        <Button>Send a comment</Button>
      </Wrapper>
    </Container>
  );
}
